import FieldAdd from '@/views/fields/FieldAdd'
import FieldDetail from '@/views/fields/FieldDetail'
import FieldListAsCard from '@/views/fields/FieldListAsCard'
import FieldListAsList from '@/views/fields/FieldListAsList'
import FieldCreate from '@/views/fields/FieldCreate'
import FieldImport from '@/views/fields/FieldImport'
import FieldPrint from '@/views/fields/FieldPrint'
import FieldSets from '@/views/fields/FieldSets'
import NowNow from '@/views/now/NowNow'
import MarketInsights from '@/views/market/MarketInsights'
import Feed from '@/views/feed/Feed'
import PoiRecords from '@/views/records/PoiRecords'
import WorkRecords from '@/views/records/WorkRecords'
import WorkEditor from '@/views/records/WorkEditor'
import WorkDetail from '@/views/records/WorkDetail'
import VraMap from '@/views/records/VraMap'
import MapView from '@/views/map/MapView'
import FeedConnections from '@/views/feed/FeedConnections'
import TaskListAsCalendar from '@/views/tasks/TaskListAsCalendar'
import TaskListAsList from '@/views/tasks/TaskListAsList'
import RefLineListAsList from '@/views/reflines/RefLineListAsList'
import RefLineImport from '@/views/reflines/RefLineImport'
import RefLineAdd from '@/views/reflines/RefLineAdd'
import UserSettings from '@/views/user/UserSettings'
import UserIcon from '@/views/user/UserIcon'
import UserResetPassword from '@/views/user/UserResetPassword'
import UserPassword from '@/views/user/UserPassword'
import UserPasswordSuccess from '@/views/user/UserPasswordSuccess'
import UserConnections from '@/views/connections/UserConnections'
import UserInvitations from '@/views/connections/UserInvitations'
import ApplicationConsole from '@/views/ApplicationConsole'
import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login'
import OAuthCallback from './views/OAuthCallback'
import OAuthCallbackForSSO from './views/OAuthCallbackForSSO'
import TaskDetail from './views/tasks/TaskDetail'
import TaskDetailError from './views/tasks/TaskDetailError'
import BillingMethods from '@/views/billing/BillingMethods'
import BillingBilling from '@/views/billing/BillingBilling'
import RefLineDetail from '@/views/reflines/RefLineDetail'
import PlantingListAsList from '@/views/plantings/PlantingListAsList'
import SolidMoistureListAsList from '@/views/observations/SoilMoistureListAsList'
import AccumulatedTemperatureListAsList from '@/views/observations/AccumulatedTemperatureListAsList'
import CasterInfo from '@/views/caster/CasterInfo'
import CasterLog from '@/views/caster/CasterLog'
import FreeDashBoard from './views/FreeDashBoard'
import ShopifySSO from './views/ShopifySSO'
import ApplicationConfig from '@/lib/application-config'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  //-------------------------
  // Routing設定
  //-------------------------
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requireAuth: false },
    },
    //-----------------
    // FreeDashBoard
    //-----------------
    {
      path: '/free',
      name: 'FreeDashBoard',
      component: FreeDashBoard,
      meta: { requireAuth: true },
    },
    //-----------------
    // OAuthCallback用
    //-----------------
    {
      path: '/oauth_callback',
      name: 'OAuthCallback',
      component: OAuthCallback,
      meta: { requireAuth: false },
    },
    //-----------------
    // ShopifySSO時専用OAuthCallback用
    //-----------------
    {
      path: '/oauth_callback/sso',
      name: 'OAuthCallbackForSSO',
      component: OAuthCallbackForSSO,
      meta: { requireAuth: false },
    },
    //-----------------
    // 管理者専用
    //-----------------
    {
      path: '/app/console',
      name: 'ApplicationConsole',
      component: ApplicationConsole,
      meta: { requireAuth: true },
    },

    //-----------------
    // 作付
    //-----------------
    {
      path: '/plantings/list',
      name: 'PlantingListAsList',
      component: PlantingListAsList,
      meta: { requireAuth: true },
    },

    //-----------------
    // 圃場
    //-----------------
    {
      path: '/fields/add',
      name: 'FieldAdd',
      component: FieldAdd,
      meta: { requireAuth: true },
    },
    {
      path: '/fields/create',
      name: 'FieldCreate',
      component: FieldCreate,
      meta: { requireAuth: true },
    },
    {
      path: '/fields/import',
      name: 'FieldImport',
      component: FieldImport,
      meta: { requireAuth: true },
    },
    {
      path: '/fields/card',
      name: 'FieldListAsCard',
      component: FieldListAsCard,
      meta: { requireAuth: true },
    },
    {
      path: '/fields/list',
      name: 'FieldListAsList',
      component: FieldListAsList,
      meta: { requireAuth: true },
    },
    {
      path: '/fields/print',
      name: 'FieldPrint',
      component: FieldPrint,
      meta: { requireAuth: true },
    },
    {
      path: '/fields/sets',
      name: 'FieldSets',
      component: FieldSets,
      meta: { requireAuth: true },
    },
    {
      path: '/fields/:key',
      name: 'FieldDetail',
      component: FieldDetail,
      meta: { requireAuth: true },
    },

    //-----------------
    // 作業
    //-----------------
    {
      path: '/tasks/list',
      name: 'TaskListAsList',
      component: TaskListAsList,
      meta: { requireAuth: true },
    },
    {
      path: '/tasks/calendar',
      name: 'TaskListAsCalendar',
      component: TaskListAsCalendar,
      meta: { requireAuth: true },
    },
    {
      path: '/tasks/:key',
      name: 'TaskDetail',
      component: TaskDetail,
      meta: { requireAuth: true },
    },
    {
      path: '/tasks/direct/:key',
      name: 'TaskDetailDirect',
      component: TaskDetail,
      meta: { requireAuth: true },
    },
    {
      path: '/tasks/error',
      name: 'TaskDetailError',
      component: TaskDetailError,
      meta: { requireAuth: true },
    },

    //-----------------
    // 基準線
    //-----------------
    {
      path: '/reflines/add',
      name: 'RefLineAdd',
      component: RefLineAdd,
      meta: { requireAuth: true },
    },
    {
      path: '/reflines/import',
      name: 'RefLineImport',
      component: RefLineImport,
      meta: { requireAuth: true },
    },
    {
      path: '/reflines/list',
      name: 'RefLineListAsList',
      component: RefLineListAsList,
      meta: { requireAuth: true },
    },
    {
      path: '/reflines/:key',
      name: 'RefLineDetail',
      component: RefLineDetail,
      meta: { requireAuth: true },
    },

    //-----------------
    // 観測
    //-----------------
    {
      path: '/observations/pf',
      name: 'SolidMoistureListAsList',
      component: SolidMoistureListAsList,
      meta: { requireAuth: true },
    },
    {
      path: '/observations/at',
      name: 'AccumulatedTemperatureListAsList',
      component: AccumulatedTemperatureListAsList,
      meta: { requireAuth: true },
    },

    //-----------------
    // Now
    //-----------------
    {
      path: '/now',
      name: 'NowNow',
      component: NowNow,
      meta: { requireAuth: true },
    },

    //-----------------
    // User
    //-----------------
    {
      path: '/user/settings',
      name: 'UserSettings',
      component: UserSettings,
      meta: { requireAuth: true },
    },
    {
      path: '/user/icon',
      name: 'UserIcon',
      component: UserIcon,
      meta: { requireAuth: true },
    },
    {
      path: '/user/passwd/reset',
      name: 'UserResetPassword',
      component: UserResetPassword,
      meta: { requireAuth: false },
    },
    {
      path: '/user/passwd',
      name: 'UserPassword',
      component: UserPassword,
      meta: { requireAuth: true },
    },
    {
      path: '/user/passwd/success',
      name: 'UserPasswordSuccess',
      component: UserPasswordSuccess,
      meta: { requireAuth: true },
    },

    //-----------------
    // Caster
    //-----------------
    {
      path: '/caster/info',
      name: 'CasterInfo',
      component: CasterInfo,
      meta: { requireAuth: true },
    },
    {
      path: '/caster/logs',
      name: 'CasterLog',
      component: CasterLog,
      meta: { requireAuth: true },
    },

    //-----------------
    // Connections
    //-----------------
    {
      path: '/connections/users',
      name: 'UserConnections',
      component: UserConnections,
      meta: { requireAuth: true },
    },
    {
      path: '/connections/invitaions',
      name: 'UserInvitations',
      component: UserInvitations,
      meta: { requireAuth: true },
    },

    //-----------------
    // Billing
    //-----------------
    {
      path: '/billing',
      name: 'BillingBilling',
      component: BillingBilling,
      meta: { requireAuth: true },
    },
    {
      path: '/market-insights',
      name: 'MarketInsights',
      component: MarketInsights,
      meta: { requireAuth: true },
    },
    {
      path: '/feed',
      name: 'Feed',
      component: Feed,
      meta: { requireAuth: true },
    },
    {
      path: '/map',
      name: 'MapView',
      component: MapView,
      meta: { requireAuth: true },
    },
    {
      path: '/vra',
      name: 'VraMap',
      component: VraMap,
      meta: { requireAuth: true },
      // VRAマップ (beta) は本番では一旦オフ (直接アクセスも遮断)
      beforeEnter: (to, from, next) => {
        ApplicationConfig.isVraMapEnabled() ? next() : next('/')
      },
    },
    {
      // 高低差マップ: VRAマップと同じ zone_maps 構造 (指数 ELEV) の別画面
      path: '/elevation',
      name: 'ElevationMaps',
      component: VraMap,
      props: { mode: 'elev' },
      meta: { requireAuth: true },
      beforeEnter: (to, from, next) => {
        ApplicationConfig.isElevationMapEnabled() ? next() : next('/')
      },
    },
    {
      path: '/works/edit',
      name: 'WorkEditor',
      component: WorkEditor,
      meta: { requireAuth: true },
    },
    {
      path: '/works/:id',
      name: 'WorkDetail',
      component: WorkDetail,
      meta: { requireAuth: true },
    },
    {
      path: '/works',
      name: 'WorkRecords',
      component: WorkRecords,
      meta: { requireAuth: true },
    },
    {
      path: '/records/poi',
      name: 'PoiRecords',
      component: PoiRecords,
      meta: { requireAuth: true },
    },
    {
      path: '/feed/connections',
      name: 'FeedConnections',
      component: FeedConnections,
      meta: { requireAuth: true },
    },
    {
      path: '/billing/methods',
      name: 'BillingMethods',
      component: BillingMethods,
      meta: { requireAuth: true },
    },

    //-----------------
    // ShopifySSO
    //-----------------
    {
      path: '/sso/shopify',
      name: 'ShopifySSO',
      component: ShopifySSO,
      meta: { requireAuth: false },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})
